var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"disabled":_vm.isDisabled,"content":_vm.tooltip,"placement":"top","popper-class":"chip-tooltip"}},[_c('chip',_vm._g(_vm._b({staticClass:"chip-icon"},'chip',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }